import { memo } from 'react';
import { BsFillPencilFill } from 'react-icons/bs';
import {
  IDetailProfileInfoFC as IFullName,
  RoleViewEnum,
  UserSettingEnum,
} from '../../../../interfaces/profile.interface';
import BlueTick from '../BlueTick';

const FullName: React.FC<IFullName> = ({ data, roleView, setModal }) => {
  return (
    <>
      <div className="group xl:w-full xl:justify-start flex gap-3 items-center justify-center relative">
        {roleView === RoleViewEnum.Owner && (
          <div className="sm:hidden w-[16px] h-[16px]"></div>
        )}
        <div className="text-primary_black text-lg py-3 text-center w-auto ">
          {data?.title && (
            <span className="text-secondary uppercase">{data?.title}. </span>
          )}
          {data?.info?.fullName}
          {/* {JSON.stringify(data)} */}
        </div>
        {data?.hasBlueTick && (
          <div className="-ml-2">
            <BlueTick />
          </div>
        )}
        {roleView === RoleViewEnum.Owner && (
          <div className="sm:hidden group-hover:block w-[16px] h-[16px] flex justify-center items-center">
            <BsFillPencilFill
              className="text-primary cursor-pointer"
              onClick={() => {
                setModal({
                  isOpen: true,
                  name: UserSettingEnum.Fullname,
                  value: data,
                });
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default memo(FullName);
